export function normalizeAppVersion(value) {
  return String(value || '').trim();
}

export function compareAppVersions(a, b) {
  const aParts = normalizeAppVersion(a).split('.').map((part) => Number.parseInt(part, 10));
  const bParts = normalizeAppVersion(b).split('.').map((part) => Number.parseInt(part, 10));
  const maxLength = Math.max(aParts.length, bParts.length);

  for (let index = 0; index < maxLength; index += 1) {
    const aValue = Number.isFinite(aParts[index]) ? aParts[index] : 0;
    const bValue = Number.isFinite(bParts[index]) ? bParts[index] : 0;
    if (aValue > bValue) return 1;
    if (aValue < bValue) return -1;
  }
  return 0;
}

export function isAppUpdateAvailable({
  availableVersion,
  currentVersion,
  availableBuildId,
  currentBuildId,
}) {
  const versionComparison = compareAppVersions(availableVersion, currentVersion);
  if (versionComparison > 0) return true;
  if (versionComparison < 0) return false;

  const nextBuildId = normalizeAppVersion(availableBuildId);
  const activeBuildId = normalizeAppVersion(currentBuildId);
  return Boolean(
    nextBuildId &&
    activeBuildId &&
    nextBuildId !== 'unknown' &&
    activeBuildId !== 'unknown' &&
    nextBuildId !== activeBuildId
  );
}

export function getAppUpdateKey(version, buildId) {
  const normalizedVersion = normalizeAppVersion(version);
  const normalizedBuildId = normalizeAppVersion(buildId);
  return normalizedBuildId ? `${normalizedVersion}:${normalizedBuildId}` : normalizedVersion;
}
